import { MiLoader } from "@miplatform/components";
import { useTheme } from "@mui/material";

export function LoadingPage() {
  const theme = useTheme();

  return (
    <MiLoader
      isLoading
      loaderColor={theme.palette.primary.main}
      style={{
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
      }}
    />
  );
}
